<div class="vh_center mt-4">
    <div col="12">
        <div style=" margin:0px; " class="vh_center">
            <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #fcb816;"></div>
            <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #dadada;"></div>
            <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #dadada;"></div>
            <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #dadada;"></div>
            <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
        </div>
    </div>
</div>
<div class="vh_center mt-2">
    <div col="12">
        <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
        <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
        <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
        <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
        <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
        <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
        </div>
    </div>
</div>
<section class="container-fluid">
    <div >
      <!-- *ngIf="processFlowObj.bomTable" -->
        <div class="fs-4 fw-b mb-2 mt-2 text-center"> BOM Pre-processor </div>
        <div class="fs-14 mb-2 mt-2 text-center">We have completed an initial validation of your BOM, and any identified issues are highlighted in red below.<br>
          You have the option to address these issues on this screen either by clicking on the line item, or by uploading an updated BOM. <br>
          One or more line items can be deleted by selecting the line item (check box) and clicking on 'Delete' button. <br>
        </div>
        @if(this.commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'){
          <div class="fs-14 mb-2 mt-2 text-center">
            NOTE: You will not be able to proceed to get component and assembly pricing until all the issues are fixed.</div>
        }
        @if(this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
          <div class="fs-14 mb-2 mt-2 text-center"> NOTE: You will not be able to proceed until all the issues are fixed.</div>
        }
        <div class="">
          <!-- <div class="text-right" style="padding-right: 2.6rem;">
            <a class="btn btn-warning" href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" download><img class="sample-bom-icon" src="https://sca-sample-bom-file.s3.amazonaws.com/excel-file-30.png" style="height: 35px;width: 35px;" />Download custom BOM format</a>
          </div> -->
          <div class="mt10 mt-4 bom-table UPLOAD_BOM" style="width:100% !important;display: block;">
            <div class="table-row table-responsive" id="bom-table-id">
              <table class="table">
                <thead class="table_header">
                  <tr>
                    <!-- <th>
                      <input type="checkbox" name="">
                    </th> -->
                    @if(bomDataItems['lineItems'] && bomDataItems['lineItems'].length>0){
                      <th style="width: 2%;"><input type="checkbox" [(ngModel)]="headerCheck" (click)="checkedLineItem('all')" color="light" /></th>
                    }
                    <th style="width: 8%;">Item number</th>
                    <th style="width: 16%;">MPN</th>
                    <th style="width: 15%;">Part Number</th>
                    <th style="width: 15%;">Manufacturer</th>
                    <th style="width: 8%;">Quantity</th>
                    <th style="width: 15%">Reference designators</th>
                    <!-- <th style="width: 6%;">Vendor</th> -->
                    <!-- <th>Alt. Vendor</th>
                    <th>Alt. Vendor Part Number</th> -->
                    <!-- <th style="width: 8%;">Value</th>
                    <th style="width: 10%;">Footprint/Size</th>
                    <th style="width: 13%;">Part description/ Specs</th> -->
                    <th style="width: 5%;">DNI</th>
                    <th style="width: 20%">Status</th>
                  </tr>
                </thead>
                <tbody>
                  @for (lit of bomDataItems['lineItems']; track lit; let i = $index) {
                    <tr [ngClass]="{'bg_red_row_hilt': lit.status != 'Valid','fw-bold': bomDataItems['selectedBOMFile']?.imported?.item_num == lit.imported?.item_num}">
                      <td>
                        <input type="checkbox" [(ngModel)]="lit.checkedModel" (click)="checkedLineItem('')" color="light" style="z-index: 1" />
                      </td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.item_num}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.mpn}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.vpn}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.manufacturer}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.quantity}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.ref_designators}}</td>
                      <!-- <td (click)="showLineItemView(lit,i)">{{lit.imported.vendor}}</td> -->
                      <!-- <td (click)="showLineItemView(lit,i)">{{lit.imported.alt_vendor}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.alt_vpn}}</td> -->
                      <!-- <td (click)="showLineItemView(lit,i)">{{lit.imported.value}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.footprint}}</td>
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.description}}</td> -->
                      <td (click)="showLineItemView(lit,i)">{{lit.imported.do_not_install}}</td>
                      <td (click)="showLineItemView(lit,i)">
                        @if(lit.selected_part && lit.selected_part != null){
                          <div class="text-center">
                            <img src="{{lit.selected_part.links.photo_url}}" width="40"  *ngIf="lit.selected_part.links" style="display: inline-block;margin-right: 10px;"/>
                            <!-- <span>{{lit.selected_part.mpn}}</span> -->
                            <!-- <ion-item download="{{lit.selected_part.mpn}}" rel="{{lit.selected_part.links.datasheet_url}}">{{lit.selected_part.mpn}}</ion-item> -->
                            <!-- (click)="showPartWebview('mpn', lit.selected_part.mpn,lit.selected_part.links.datasheet_url)"  -->
                            <a class="text-capitalize" style="display: inline-block;width: 100px;font-size: 14px;cursor: pointer;">{{lit.selected_part.mpn}}</a>
                            <!-- <ion-button fill="clear" class="ion-text-capitalize" (click)="showPartWebview('mpn', lit.selected_part.mpn,lit.selected_part.links.datasheet_url)" style="display: block;">{{lit.selected_part.mpn}}</ion-button> -->
                            <!-- <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls">{{lit.selected_part.mpn}}</a> -->
                          </div> 
                        }@else{
                          <!-- <ng-template #showbutton> -->
                            @if(lit.statusAray.length == 0 && lit.do_not_install == ''){
                              <div>{{lit.status}}</div>
                            }
                            @if(lit.statusAray.length != 0){
                              @for (statusObj of lit.statusAray; track statusObj; let j = $index) {
                                <div class="mb-2" style="text-align: left;">{{statusObj}}</div>
                              }
                            }
                            @if(checkStatus(lit.status)){
                              <div class="text-center">
                                  <!-- (click)="fixLineItem(lit)" -->
                                <!-- <button slot="end" size="small" color="danger" class="fix-btn" >Fix</button> -->
                              </div>
                            }
                          <!-- </ng-template> -->
                        }
                      </td>
                    </tr>
                  }
                  <!-- changes for KIP-1115 -->
                   @if(bomDataItems['lineItems']?.length==0){
                    <tr><td colspan="13" class="text-center" style="padding: 9rem;font-weight: bold;font-size: 16px;">{{showNoDataMsg}}</td></tr>
                   }
                </tbody>
              </table>
            </div>
            @if(showLineItemEdit){
            <div class="line-item-edit mb-5">
                    <!--  [formGroup]="registrationForm" -->
              <table class="table">
                <tbody>
                  <tr [ngClass]="{'bg_red_row_hilt': selectedBomObj.status != 'Valid'}" class="fw-bold">
                    <td style="width: 2%;"><input type="checkbox" name="lineEdit" /></td>
                    <td style="width: 8%;">{{selectedBomObj.imported.item_num}}</td>
                    <td style="width: 16%;">{{selectedBomObj.imported.mpn}}</td>
                    <td style="width: 15%;">{{selectedBomObj.imported.vpn}}</td>
                    <td style="width: 15%;">{{selectedBomObj.imported.manufacturer}}</td>
                    <td style="width: 8%;">{{selectedBomObj.imported.quantity}}</td>
                    <td style="width: 15%;">{{selectedBomObj.imported.ref_designators}}</td>
                    <!-- <td style="width: 6%;">{{selectedBomObj.imported.vendor}}</td> -->
                    <!-- <td>{{selectedBomObj.imported.alt_vendor}}</td>
                    <td>{{selectedBomObj.imported.alt_vpn}}</td> -->
                    <!-- <td style="width: 8%;">{{selectedBomObj.imported.value}}</td>
                    <td style="width: 10%;">{{selectedBomObj.imported.footprint}}</td>
                    <td style="width: 13%;">{{selectedBomObj.imported.description}}</td> -->
                    <td style="width: 5%;">{{selectedBomObj.imported.do_not_install}}</td>
                    <td style="width: 20%;">
                      @if(selectedBomObj.selected_part.links){
                        <div class="ion-text-center">
                          <img src="{{selectedBomObj.selected_part.links.photo_url}}" width="30"/>
                          <!-- <span>{{selectedBomObj.selected_part.mpn}}</span> -->
                          <!-- <ion-item download="{{selectedBomObj.selected_part.mpn}}" href="{{selectedBomObj.selected_part.links.datasheet_url}}">{{selectedBomObj.selected_part.mpn}}</ion-item> -->
                          <a download target="_blank" href="{{selectedBomObj.selected_part.links.datasheet_url}}" style="display: block;cursor: pointer;">{{selectedBomObj.selected_part.mpn}}</a>
                          <!-- <ion-button fill="clear" *ngIf="selectedBomObj.selected_part.links" class="ion-text-capitalize" (click)="showPartWebview('mpn', selectedBomObj.selected_part.mpn,selectedBomObj.selected_part.links.datasheet_url)" style="display: block;">{{selectedBomObj.selected_part.mpn}}</ion-button> -->
                          <!-- <ion-button fill="clear" class="ion-text-capitalize" (click)="showPartWebview('mpn', selectedBomObj.selected_part.mpn,selectedBomObj.selected_part.links.datasheet_url)"><u>{{selectedBomObj.selected_part.mpn}}</u></ion-button> -->
                        </div> 
                      } @else{
                        <!-- <ng-template #showbutton> -->
                          @if(selectedBomObj.statusAray.length == 0){
                            <div>{{selectedBomObj.status}}</div>
                          }@else{
                            @for (statusObj of selectedBomObj.statusAray; track statusObj; let i = $index){
                              <div class="mb-2" style="text-align: left;">{{statusObj}}</div>
                            }
                          }
                          <!-- <div>{{selectedBomObj.status}}</div> -->
                          @if(checkStatus(selectedBomObj.status)){
                            <div class="text-center">
                                <!-- (click)="fixLineItem(selectedBomObj)" -->
                              <!-- <button slot="end" size="small" color="danger" class="fix-btn">Fix</button> -->
                            </div>
                          }
                        <!-- </ng-template> -->
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="edit_tabs"> 
                <div class="d_ib" [ngClass]="{'active': lineItemEdit == 'Edit'}" style="width: 5%;" (click)="lineItemEdit = 'Edit'">Edit</div>
                <!-- <div class="d_ib" [ngClass]="{'active': lineItemEdit == 'Part'}" style="width: 10%;" (click)="lineItemEdit = 'Part'">Part Details</div> -->
              </div>
              @if(lineItemEdit == 'Edit' && editLineItemForm){
                <div>
                  <form [formGroup]="editLineItemForm">
                    <div class="row">
                      <div class="col-md-2 col-lg-2 col-sm-2 no-padding"></div>
                      <div class="col-md-4 col-lg-4 col-sm-4 no-padding">
                          <div>
                            <label class="fs14">Item number<span class="text-danger">*</span></label>
                            <!-- [(ngModel)]="selectedBomObj.imported.item_num" -->
                            <input type="text" class="text-left form-control" formControlName="item_num" name="itemNum" />
                          </div>
                          <div class="validation-errors fs12">
                            @for (validation of edit_line_validation_messages.item_num; track validation; let i = $index){
                              <ng-container>
                                @if(editLineItemForm.get('item_num').hasError(validation.type) && (editLineItemForm.get('item_num').dirty || editLineItemForm.get('item_num').touched)){
                                  <div class="text-danger">
                                    {{ validation.message }}
                                  </div>
                                }
                              </ng-container>
                            }
                          </div>
                          <div>
                            <!-- [(ngModel)]="selectedBomObj.imported.quantity" -->
                            <label class="fs14">Quantity<span class="text-danger">*</span></label>
                            <input type="text" class="text-left form-control" formControlName="quantity" name="quantity" />
                          </div>
                          <div class="validation-errors fs12">
                            @for (validation of edit_line_validation_messages.quantity; track validation; let i = $index){
                              <ng-container>
                                @if(editLineItemForm.get('quantity').hasError(validation.type) && (editLineItemForm.get('quantity').dirty || editLineItemForm.get('quantity').touched)){
                                  <div class="text-danger">
                                    {{ validation.message }}
                                  </div>
                                }
                              </ng-container>
                            }
                          </div>
                          <div>
                            <!-- [(ngModel)]="selectedBomObj.ref_designators"  -->
                            <label class="fs14">Ref. designator<span class="text-danger">*</span></label>
                            <input type="text" class="text-left form-control" formControlName="ref_designators" name="ref" />
                          </div>
                          <div class="validation-errors fs12">
                            @for (validation of edit_line_validation_messages.ref_designators; track validation; let i = $index){
                              <ng-container>
                                @if(editLineItemForm.get('ref_designators').hasError(validation.type) && (editLineItemForm.get('ref_designators').dirty || editLineItemForm.get('ref_designators').touched)){
                                  <div class="text-danger">
                                    {{ validation.message }}
                                  </div>
                                }
                              </ng-container>
                            }
                          </div>
                          <!-- <div class="mt-2">
                            <label class="fs14 pe-3">DNI</label>
                            <input type="checkbox" formControlName="do_not_install" name="dni" />
                          </div> -->
                      </div>
                      <div class="col-md-4 col-lg-4 col-sm-4 no-padding">
                          <div>
                            <label class="fs14">MPN<span class="text-danger">*</span></label>
                            <!-- [(ngModel)]="selectedBomObj.selected_part.mpn" -->
                            <input type="text" class="text-left form-control" formControlName="mpn" name="mpn"  />
                          </div>
                          <div class="validation-errors fs12">
                            
                            @for (validation of edit_line_validation_messages.mpn; track validation; let i = $index){
                              <ng-container>
                                @if(editLineItemForm.get('mpn').hasError(validation.type) && (editLineItemForm.get('mpn').dirty || editLineItemForm.get('mpn').touched)){
                                  <div class="text-danger">
                                    {{ validation.message }}
                                  </div>
                                }
                              </ng-container>
                            }
                          </div>
                          <div>
                            <!-- [(ngModel)]="selectedBomObj.selected_part.manufacturer.name"  -->
                            <label class="fs14">Manufacturer</label>
                            <input type="text" class="text-left form-control" formControlName="manufacturer" name="manufacturer" />
                          </div>
                          <div>
                            <!-- [(ngModel)]="selectedBomObj.imported.vpn" -->
                            <label class="fs14">Part Number</label>
                            <input type="text" class="text-left form-control" formControlName="vpn" name="vpn"  />
                          </div>
                          <!-- <div>
                            <label class="fs14">Vendor</label>
                            <input type="text" class="text-left form-control" formControlName="vendor" name="vendor" readonly />
                          </div> -->
                          <div class="mb-5">
                            <button class="m-2 mt-4 text-capitalize btn btn-custom btn-red-custom btn-danger" (click)="closeLineItemEdit()"><b>CANCEL</b></button>
                            <button class="m-2 mt-4 text-capitalize btn btn-custom btn-warning" [disabled]="!editLineItemForm.valid" (click)="saveLineItemEdit()"><b>SAVE</b></button>
                          </div>
                      </div>
                      <div class="col-md-2 col-lg-2 col-sm-2 no-padding"></div>
                      <!-- <div class="col-md-4 col-lg-4 col-sm-4 no-padding">
                          <div>
                            <label class="fs14">Value</label>
                            <input type="text" class="text-left form-control" formControlName="value" name="value" readonly />
                          </div>
                          <div>
                            <label class="fs14">Footprint</label>
                            <input type="text" class="text-left form-control" formControlName="footprint" name="footprint" readonly />
                          </div>
                          <div>
                            <label class="fs14">Description</label>
                            <input type="text" class="text-left form-control" formControlName="description" name="desc" readonly />
                          </div>
                          <div>
                            <button class="m-2 mt-4 text-capitalize btn btn-custom btn-warning" [disabled]="!editLineItemForm.valid" (click)="saveLineItemEdit()">SAVE</button>
                            <button class="m-2 mt-4 text-capitalize btn btn-custom btn-danger" (click)="closeLineItemEdit()">CANCEL</button>
                          </div>
                      </div> -->
                    </div>
                  </form>
                </div>
              }
            </div>
          }
          @if(!showLineItemEdit){
            <div class="table-bar">
              <div class="row">
                <div class="col-2">
                  <button class="btn btn-custom btn-warning btn-red-custom m-3" (click)="deleteOrUpdateLineItem('delete')" title= "Click to delete the selected line items" style="margin-left: 22px !important;"><b>Delete</b></button>
                </div>
                <div class="col-8 text-center">
                  <div class="error-cout-upload-btns">
                    @if(bomDataItems['lineItems']?.length > 0 && bomDataItems['count']?.successCount == bomDataItems['lineItems']?.length){
                      <div class="mt-4" [hidden]="countDniCheck == bomDataItems['lineItems']?.length && bomDataItems['count']?.errorCount>0">
                        <span class="success-count">
                            Your BOM is clean!
                        </span>
                      </div>
                    }
                    @if(bomDataItems['lineItems']?.length > 0 && bomDataItems['count']?.errorCount>0){
                      <div class="mt-4">
                        <span class="error-count">You have {{bomDataItems['count']?.errorCount}} line item errors!</span>
                      </div>
                    }
                    <div class="upload-btn-sec">
                      <input type="file" name="customFileUpload" class="form-control" id="customFileUpload" accept=".xls,.xlsx" (change)="callUploadFilesLogic(bomAutoMapping,$event)" value="null" style="display: none;visibility: hidden;"/>
                      <div class="upload-bom-tooltip">
                        <button type="button" class="btn btn-custom btn-warning " data-mdb-toggle="button" autocomplete="off" aria-pressed="true" accept=".xls,.xlsx"(mouseover)="showToolTip(1)" (mouseout)="hideToolTip(1)" (click)="uploadFiles(bomAutoMapping,$event)" style="margin-right: 1rem;"> <i class="fa fa-cloud-upload text-white" aria-hidden="true"></i> <b> &nbsp;Upload a Different BOM</b>
                        </button>
                        <span class="tooltiptext" id="bomPreprocess-1"></span>
                      </div>
                      <!-- <label for="customFileUpload">
                        <div class="btn btn-warning fs14 me-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="checkUserSessionBeforeUpload($event)" >
                        <i class="fa fa-cloud-upload text-white" aria-hidden="true"></i> <b> &nbsp;Upload New BOM</b>
                        </div>
                      </label> -->
                      <div class="text-center excel-info-txt">(Accepted formats: .xls, .xlsx)</div>
                      <div class="ion-text-left fs15 mt5 pl5">
                        <a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" style="position: relative; left: -6px;">Download custom BOM format</a>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="card-header theme-txt font15">
                      <b>Sierra Sample BOM</b>
                  </div>
                  <div class="mt-5 mb-3" style="position: relative;bottom: 28px;left: 12px;">
                      <p class="mb-0" style="font-size: larger;color: #007bff;font-weight: 500;">*Please use this sample template to create/upload BOM in Sierra Circuits recommended format</p>
                      <p class="mb-0 text-center"><a href="https://sca-sample-bom-file.s3.amazonaws.com/BOM-Sample-and-Demo.xls" download><img src="https://sca-sample-bom-file.s3.amazonaws.com/excel-file-30.png" style="height: 35px;width: 35px;" /></a></p>
                      <p class="mb-0 text-center" style="font-size: larger;color: #007bff;font-weight: 500;">Sample BOM</p> 
                  </div> -->
                </div>
                <!-- <div class="col-3"> -->
                  <!-- <div class="mb-4"> -->
                    <!-- [disabled]="buttonsDisabled"  -->
                    <!-- <div style="display: inline-block;"> -->
                    <!-- <button class="btn btn-small btn-warning m-2" (click)="deleteOrUpdateLineItem('DNI')" title="Click to mark the selected line item as DNI">DNI</button> -->
                    
                    <!-- (click)="addNewLineItem(this.lostBomItemIndex, this.bomId)" -->
                    <!-- <button class="btn btn-small btn-warning m-2" style="width: 30%" title="Click to add the new line item">New item</button> -->
                    <!-- </div>
                    <div class="mt-5 text-center pr0 pl0"> -->
                    <!-- <button class="btn btn-small btn-warning m-2" (click)="routeCustomUpload()" title="">Upload New BOM </button> -->
                    <!-- </div> -->
                    <!-- <div size="3.5" class="pl0">
                    <div class="padding error-count" *ngIf="bomDataItems['lineItems'].length > 0 && bomDataItems['count'].errorCount>0">
                        You have {{bomDataItems['count'].errorCount}} line item errors.
                    </div> -->
                    <!-- </div> -->
                    <!-- <div class="mt-5 text-center pr0 pl0 text-center"> -->
                    
                    <!-- [disabled]="bomDataItems['lineItems'].length == 0 || bomDataItems['count'].errorCount>0 || countDniCheck == bomDataItems['lineItems'].length" OFP-613 -->
                  <!-- </div> -->
                <!-- </div> -->
                <div class="col-2">
                  <button class="btn btn-custom btn-warning btn_blue_custom m-3" (click)="bomProcessContinue()" ><b>Continue</b></button>
                </div>
              </div>
              
            </div>
          } 
                
          </div>
            
        </div>
    </div>

</section>


<ng-template #bomAutoMapping let-modal class="auto-mapping-modal">
    <div class="modal-header">
      <div class="row col">
        <div class="col-11">
          <h4 class="modal-title" id="modal-basic-title">BOM Column Mapping</h4>
        </div>
        <div class="col-1 text-right">
          <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="modal-crose">×</span>
          </button>
        </div>
      </div>
    </div>
  @if(showNumberOfSheets){
    <div class="modal-body pt-0">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center mb-3"><b><u>Map the column headings for your BOM</u></b></div>
          <div class="text-center fs14 text-danger"> <b>Note: </b> Please select the column name for the mandatory columns that are not auto-mapped. If any of the mandatory columns are not present in the BOM, click on "Cancel" button and upload a new BOM that has all the mandatory columns.</div>
        </div>
      </div>
      <!-- Changes done based on OFP-652 -->
      <!-- REQUIRED FIELDS -->
      <div [hidden]="mainRowArrayObj['labelsArray']?.length == 0">
        @for (cma of mainRowArrayObj['labelsArray']; track cma; let idx = $index) {
          <div class="row justify-content-md-center" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
            @if((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
            <div class="row justify-content-md-center">
              <div class="col-sm-3">
                @if(cma.labelType != 'new'){
                  <label>{{cma.labelName}}
                  @if((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
                      <span class="text-danger">*</span>
                    }
                  </label>
                }
              </div>
              <div class="col-sm-4">
                <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                  <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" [ngClass]="cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number' ? 'requiredField' : 'notRequireField'" placeholder="Select" [(ngModel)]="cma.selectedName1" (change)="checkIfAllOptionsPresent()">
                    <option value="">Select</option>
                      @for (crow of mainRowArrayObj['bomOneMapArrayData']; track crow; let indx = $index) {
                        <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj">
                          {{crow.labelValue}}
                        </option>
                      }
                  </select>
                </div>
            </div>
          }
          </div>
        }
      </div>
      <!-- NOT REQUIRED FIELDS -->
      <div [hidden]="mainRowArrayObj['labelsArray']?.length == 0">
        @for (cma of mainRowArrayObj['labelsArray']; track cma; let idx = $index) {
          <div class="row justify-content-md-center" [hidden]="cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'">
            @if(!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
              <div class="row justify-content-md-center">
                <div class="col-sm-3">
                  @if(cma.labelType != 'new'){
                    <label>{{cma.labelName}}
                      @if((cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
                        <span class="text-danger">*</span>
                      }
                      </label>
                  }
                </div>
                <div class="col-sm-4">
                  <!-- (change)="changeColumnData(idx,cma.selectedName1,'1')" -->
                    <select id="columnMap_{{idx}}" class="form-control form-select mb-3 header-mapping-dropdown" placeholder="Select" [(ngModel)]="cma.selectedName1">
                      <option value="">Select</option>
                        @for (crow of mainRowArrayObj['bomOneMapArrayData']; track crow; let idxx = $index) {
                          <option value="{{crow.selectedObj}}" [selected]="cma.selectedName1 == crow.selectedObj">
                            {{crow.labelValue}}
                          </option>
                        }
                    </select>
                  </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if(!showNumberOfSheets){
    <div class="modal-body">
      <div class="row m-0 mt-2 mb-3">
        <div class="col">
          <div class="text-center clr_green mb-5"><b>Your excel has multiple worksheets. Please specify worksheet that has BOM info.</b></div>
          <div class="row justify-content-md-center">
            <div class="col-sm-3">
                <label>Select Sheet: </label>
            </div>
            <div class="col-sm-4">
                <select class="form-control form-select mb-3" placeholder="Select" [(ngModel)]="selectedSheetNum">
                  <option value="">Select</option>
                  @for (sheet of sheetsArray; track sheet; let i = $index) {
                    <option value="{{sheet.index}}">
                      {{sheet.name}}
                    </option>
                  }
                </select>
              </div>
          </div>
        </div>
      </div>
    </div>
  } 
  @if(!showNumberOfSheets){
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5" (click)="proceedSheet()"><b>Proceed</b></button>
    </div>
  }
  @if(showNumberOfSheets){
    <div class="modal-footer text-center" style="display: block;">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 mr-25 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
      <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5" (click)="proceedAutoMapData()" ><b>Proceed</b></button>
      <!-- (click)="modal.close('Save click')" [disabled]="disableAutomapProceed == true" OFP-613 -->
    </div>
  }
  </ng-template>
